/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businesscreatedbutemailfaileddescription5Inputs */

const en_businesscreatedbutemailfaileddescription5 = /** @type {(inputs: Businesscreatedbutemailfaileddescription5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The customer must be informed of their credentials manually.`)
};

const de_businesscreatedbutemailfaileddescription5 = /** @type {(inputs: Businesscreatedbutemailfaileddescription5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Kunde muss manuell über seine Zugangsdaten informiert werden.`)
};

/**
* | output |
* | --- |
* | "The customer must be informed of their credentials manually." |
*
* @param {Businesscreatedbutemailfaileddescription5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businesscreatedbutemailfaileddescription5 = /** @type {((inputs?: Businesscreatedbutemailfaileddescription5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businesscreatedbutemailfaileddescription5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businesscreatedbutemailfaileddescription5(inputs)
	return de_businesscreatedbutemailfaileddescription5(inputs)
});
export { businesscreatedbutemailfaileddescription5 as "businessCreatedButEmailFailedDescription" }